__turbopack_context__.v({
  "className": "geist_53ceb966-module__JNc1LW__className",
  "variable": "geist_53ceb966-module__JNc1LW__variable",
});
